<template>
  <vs-popup
    class="custom-popup"
    :active.sync="showPopup"
    @close="closePopup"
    title=""
  >
    <vx-card>
      <div class="vx-card__title mb-4">
        <h2 class="mb-4">Редактирование пункта</h2>
        <p>Редактирование всех доступных настроек пункта меню</p>
      </div>
      <div class="vx-row">
        <div class="vx-col w-2/12">
          <vs-input
            class="w-full"
            label="№:"
            name="code_step"
            type="number"
            v-model.number="currentSettings.stepCode"
            :class="isEditedClass(currentSettings.stepCode, settings.stepCode)"
          />
        </div>
        <div class="vx-col w-10/12">
          <vs-input
            class="w-full mb-6"
            label="Название:"
            name="title"
            v-model="currentSettings.title"
            :class="isEditedClass(currentSettings.title, settings.title)"
          />
          <vs-checkbox
            class="mb-6"
            v-model="currentSettings.triggerRequest"
            :class="isEditedClass(currentSettings.triggerRequest, settings.triggerRequest)"
          >Сделать этот пункт заказом обратного звонка
          </vs-checkbox>
          <div v-if="currentSettings.triggerRequest" class="w-3/4">
            <div class="flex items-center">
              <div class="vs-input--label mr-2">Дополнительные email-получатели:</div>
              <vx-tooltip :text="'Здесь можно указать дополнительные адреса, на которые будет приходить уведомление о заказе обратного звонка (в дополнении к настройкам канала и входящей группе операторов)'">
                <vs-icon
                  icon-pack="feather"
                  icon="icon-info"
                />
              </vx-tooltip>
            </div>
            <SelectInPopup
              taggable
              multiple
              name="emails"
              v-validate="'email'"
              v-model="currentSettings.additionalEmailReceivers"
            >
              <span slot="no-options">Укажите почту</span>
            </SelectInPopup>
            <span class="text-danger text-sm" v-show="errors.has('emails')">{{ errors.first('emails') }}</span>
            <div class="mt-6">
              <vs-checkbox
                class="mb-6"
                v-model="currentSettings.skipMenu"
                :class="isEditedClass(currentSettings.skipMenu, settings.skipMenu)"
              >Скрыть меню при заказе обратного звонка
              </vs-checkbox>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-2/12"></div>
        <div class="vx-col w-10/12">
          <div class="flex">
            <vs-button @click.prevent="clickOnSave" :disabled="!hasChanges">Сохранить</vs-button>
            <vs-button v-if="hasChanges" class="ml-6" type="border" @click.prevent="cancelChanges">Отмена</vs-button>
          </div>
        </div>
      </div>
    </vx-card>

    <ScenarioMessageTemplate
      :company-slug="companySlug"
      :scenario-slug="scenarioSlug"
      :step-id="stepId"
      @loaded="queue.push(true)"
    />

  </vs-popup>
</template>

<script>
import ScenarioSteps from '../../../api/http/models/ScenarioSteps'
import ScenarioMessageTemplate from './ScenarioMessageTemplate'
import {isEditedClass, compareObjects, copyObject} from '../../../helpers/helpers'

export default {
  props: {
    companySlug: {
      type: String,
      required: true
    },
    scenarioSlug: {
      type: String,
      required: true
    },
    stepId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showPopup: false,
      queue: [],
      currentStep: {},
      settings: {
        stepCode: '',
        title: '',
        triggerRequest: false,
        skipMenu: false,
        additionalEmailReceivers: null
      },
      currentSettings: {},
      hasChanges: false
    }
  },
  components: {
    ScenarioMessageTemplate
  },
  async created () {
    this.$vs.loading()
    const response = await ScenarioSteps.getOne(this.companySlug, this.scenarioSlug, this.stepId)
    if (response.data) {
      await this.setData(response.data)
      await this.copySettings()
    }
    this.queue.push(true)
  },
  watch: {
    currentSettings: {
      deep: true,
      handler (newValue) {
        this.hasChanges = !compareObjects(this.settings, newValue)
      }
    },
    queue: {
      handler (newValue) {
        if (newValue.length >= 2) {
          this.$vs.loading.close()
          if (newValue.every(v => v === true)) {
            this.showPopup = true
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Произошла ошибка',
              text: ''
            })
          }
        }
      }
    }
  },
  methods: {
    isEditedClass,
    setData (data) {
      this.currentStep = data
      this.settings.stepCode = this.currentStep.step_code
      this.settings.title = this.currentStep.title
      this.settings.triggerRequest = this.currentStep.settings && this.currentStep.settings['callback.trigger_request'] ? this.currentStep.settings['callback.trigger_request'] : false
      this.settings.skipMenu = this.currentStep.settings && this.currentStep.settings['callback.skip_menu'] ? this.currentStep.settings['callback.skip_menu'] : false
      this.settings.additionalEmailReceivers = this.currentStep.settings && this.currentStep.settings['callback.additional_email_receivers'] ? this.currentStep.settings['callback.additional_email_receivers'] : null
    },
    copySettings () {
      this.currentSettings = copyObject(this.settings)
    },
    async clickOnSave () {
      const validate = await this.$validator.validateAll()

      if (validate) {
        const response = await ScenarioSteps.updateOne(this.companySlug, this.scenarioSlug, this.stepId, {
          title: this.currentSettings.title,
          step_code: this.currentSettings.stepCode,
          settings: {
            ['callback.trigger_request']: this.currentSettings.triggerRequest,
            ['callback.skip_menu']: this.currentSettings.skipMenu,
            ['callback.additional_email_receivers']: this.currentSettings.additionalEmailReceivers || null
          }
        })
        if (response.status === 'success') {
          await this.setData(response.data)
          await this.copySettings()
          await this.$emit('update', this.currentStep)
          this.$vs.notify({
            color: 'success',
            title: 'Шаг успешно обновлен',
            text: ''
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: 'Произошла ошибка при сохранении',
            text: ''
          })
        }
      }
    },
    cancelChanges () {
      this.copySettings()
    },
    closePopup () {
      this.$emit('close')
    }
  }
}
</script>
